import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UiState {
  sidebarCollapsed: boolean;
  globalLoading: boolean;

  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  setGlobalLoading: (v: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      globalLoading: false,

      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setGlobalLoading: (v) => set({ globalLoading: v }),
    }),
    {
      name: 'witzy-ui',
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
    },
  ),
);
